import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import AcedSelect, {
	SelectOption,
	SelectOptions,
} from "../../../components/essentials/input/select/AcedSelect";
import http from "../../../shared/utils/http";

const SelectLeague = () => {
	const { t } = useTranslation();

	const [leagues, setLeagues] = useState<SelectOptions>([]);

	const { control, watch } = useFormContext();
	const watchCategory = watch("category");

	useEffect(() => {
		if (!watchCategory) {
			setLeagues([]);
			return;
		}
		http.get(`/utils/leagues?category=${watchCategory}`).then((response) => {
			const leagueOptions: SelectOption[] = response.map(
				(value: { name: string; category: string }) =>
				({
					value: value.name,
					label: value.name,
				} as SelectOption)
			);
			setLeagues(leagueOptions);
		});
	}, [watchCategory]);

	return (
		<AcedSelect
			label={t("common.words.league")}
			control={control}
			options={leagues}
			placeholder={t("createJob.placeholder.select")}
			name="league"
			isDisabled={!watchCategory}
			rules={{ required: t("createJob.validation.required") }}
		/>
	);
};

export default SelectLeague;
